import { createFileRoute } from "@tanstack/react-router";
import { ExpeditionsListPage } from "~/pages/expeditions/ExpeditionsListPage";
export const Route = createFileRoute("/_authenticated/expeditions/")({ component: ExpeditionsListPage });
